import React from 'react';

import { Exercises } from '@/presentation/screens/exercises/exercises';

import { ClassroomViewModel, Lesson } from '../../../classroom.vm';
import { CurrentLessonHeader } from '../current-lesson-header';

interface LessonProps {
  mobileSidebarOpen: boolean;
  title: string;
  onClose: () => void;
}

interface LessonExercisesProps {
  lesson?: Lesson;
  urlExercise?: string;
  currentExercise?: { lesson_guid: string; exercises_guid: string };
  showResult?: boolean;
  isLoadingExercise?: boolean;
  vm?: ClassroomViewModel;
}

export const ExercisesContainer = ({
  mobileSidebarOpen,
  title,
  onClose,
  showResult,
  isLoadingExercise,
  vm,
}: LessonProps & LessonExercisesProps) => {
  return (
    <div className={`current-lesson ${mobileSidebarOpen ? 'hidden' : ''}`}>
      <CurrentLessonHeader title={title} onClose={onClose} />
      <Exercises vm={vm} showResult={showResult} isLoadingExercise={isLoadingExercise} />
    </div>
  );
};
